import { render, staticRenderFns } from "./NoticeAttachmentPanel.vue?vue&type=template&id=830fae80&"
import script from "./NoticeAttachmentPanel.vue?vue&type=script&lang=js&"
export * from "./NoticeAttachmentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports